

export const statusList = [
    '全部','待处理','处理中','已完成'
]